import React from 'react';
import './OptionCard.scss';
import classNames from 'classnames';

const AdvancedOptionCard = props => {
  const { title, body, onClick, linkText, inlineArrowOnSelect, selected, background, className } = props;

  return (
    <div
      className={classNames('option-card advanced-option-card', className, {
        'inline-arrow-on-select': inlineArrowOnSelect,
        selected: selected,
      })}
      style={background ? { backgroundColor: background } : undefined}
      onClick={onClick}
    >
      <div className="advanced-card-text">
        <p className="advanced-card-title">{title}</p>
        <p className="advanced-card-body">{body}</p>
      </div>
      {inlineArrowOnSelect && (
        <div
          className={classNames('arrow-link', {
            'display-none': inlineArrowOnSelect && !selected,
          })}
        >
          {linkText && <p>{linkText}</p>}
          <i className="fas fa-arrow-right"></i>
        </div>
      )}
    </div>
  );
};

export default AdvancedOptionCard;
